import { useEffect } from "react";
import { useRouter } from "next/router";

function ScrollReset() {
  const router = useRouter();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [router.pathname]);

  return null;
}

export default ScrollReset;
